import { createStore, createEffect, createEvent, combine } from 'effector';
import i18n from 'i18n';
import { $notificationStore } from '../notificationStore';
import { ApiUtils } from '@shared/utils';
import { AccountsApi } from '@shared/api/rest';
import type { TransactionsWithPaymentsRequest, TransactionsWithPaymentsResponse } from '@shared/api/rest/accounts';
import { type IQueryParams, RequestStrategyEnum } from '@shared/api/models';

const getTransactionsWithPaymentsEffect = createEffect((params: IQueryParams<TransactionsWithPaymentsRequest>) =>
  AccountsApi.getTransactionsWithPayments(params.request, params.signal),
);
const clearEvent = createEvent();

const $dataStore = createStore<{
  data: TransactionsWithPaymentsResponse[];
  total: number;
}>({ data: [], total: 0 })
  .on(getTransactionsWithPaymentsEffect.done, (_, data) =>
    data.result ? { data: data.result.data || [], total: data.result.total } : { data: [], total: 0 },
  )
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getTransactionsWithPaymentsEffect.pending, (_, data) => data)
  .on(getTransactionsWithPaymentsEffect.fail, (_, data) => ApiUtils.abortApiFailCaseTrigger(data))
  .on(getTransactionsWithPaymentsEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getTransactionsWithPaymentsEffect, () => null)
  .on(getTransactionsWithPaymentsEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getTransactionsWithPaymentsEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((x) => {
  ApiUtils.errorStoreAbortRequestWatcher(x, $notificationStore.events.setError);
});

export const $transactionsWithPaymentsStore = {
  events: {
    getTransactionsWithPayments: ApiUtils.wrapperApi(getTransactionsWithPaymentsEffect, RequestStrategyEnum.Default),
    clear: clearEvent,
  },
  store: combine({
    data: $dataStore,
    loading: $loadingStore,
    error: $errorStore,
  }),
};
